import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "input", "hider", "shower" ];

  toggle(event) {
    this.inputTarget.type = this.inputTarget.type === "password" ? "text" : "password";
    this.hiderTarget.classList.toggle("hidden");
    this.showerTarget.classList.toggle("hidden");
    event.currentTarget.setAttribute("aria-pressed", (this.inputTarget.type === "text").toString());
  }
}
